/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { parseDependencies } from './dependenciesParse.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createCompile } from '../../factoriesAny.js';
export var compileDependencies = {
  parseDependencies: parseDependencies,
  typedDependencies: typedDependencies,
  createCompile: createCompile
};